
<div class="posR pointer">
  <div data-testid="select-text-input" class="input-select" #inputSelect (click)="showOption()" [ngStyle]="{ 'width': selectWidth }">
    <div class="selectedValue">{{selectedDisplay}}</div><i class="fas fa-chevron-right fontL1"></i>
  </div>
  <div class="options" #optionsElement [ngStyle]="{ 'width': selectWidth }">
    <div data-testid="select-text-option" class="option" *ngFor="let option of options" (click)="onInputChange(option.value, option.display)">{{option.display}}</div>
  </div>
</div>